import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import AOS from "aos";
import { FaArrowRight } from "react-icons/fa";
import "aos/dist/aos.css";
import "./Information.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/bg-transport-hero.jpg";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

export default function Information() {
  const { t } = useTranslation();
  const cityCards = [
    {
      title: t("information.city_cards.berlin.title"),
      description: t("information.city_cards.berlin.description"),
    },
    {
      title: t("information.city_cards.bonn.title"),
      description: t("information.city_cards.bonn.description"),
    },
    {
      title: t("information.city_cards.bremen.title"),
      description: t("information.city_cards.bremen.description"),
    },
    {
      title: t("information.city_cards.dortmund.title"),
      description: t("information.city_cards.dortmund.description"),
    },
    {
      title: t("information.city_cards.dresden.title"),
      description: t("information.city_cards.dresden.description"),
    },
    {
      title: t("information.city_cards.dusseldorf.title"),
      description: t("information.city_cards.dusseldorf.description"),
    },
  ];
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <SEO
        title="TransCirox – Informationen | Alles über unsere Transportdienste"
        description="Nützliche Informationen und Details zu den Transportdiensten von TransCirox. Erfahren Sie alles über Ablauf, Preise und Services."
        keywords="Transport Informationen, TransCirox Services, Transportablauf, Preise Transport, Umzug Informationen"
      />
      {/* Hero Section */}
      <HeroSection
        backgroundImage={heroPhoto}
        showNavbar={true}
        showTopbar={false}
        customHeight="300px"
        showQuoteForm={false}
        showCTAButton={false}
      >
        <div className="text-left text-white" data-aos="fade-down">
          <h6 className="display-6">{t("information.hero.title")}</h6>
          <p>{t("information.hero.subtitle")}</p>
        </div>
      </HeroSection>
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center text-orange fw-bold mb-5">
            {t("information.section_title")}
          </h2>
          <Row className="g-4">
            {cityCards.map((card, idx) => (
              <Col md={6} lg={4} key={idx} data-aos="fade-left">
                <Card className="information-card shadow-sm h-100">
                  <Card.Body>
                    <Card.Title className="fw-bold text-orange">
                      {card.title}
                    </Card.Title>
                    <Card.Text>{card.description}</Card.Text>
                    <div className="custom-arrow-btn">
                      <FaArrowRight className="arrow-icon" />
                      <div></div>
                      <span className="arrow-text">
                        {t("information.read_more")}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}
